 <!-- mobile footer -->
 <div class="mobile-menu">
    <nav class="mobile-bottom-nav col-xl-none">
      <a class="mbn-col-3" href="javascript:void(0)" id="menu-toggle" (click)="toggleMenu()">
        <i class="icofont-menuclose"></i>
          <span>menu</span>
      </a>
      <a class="mbn-col-3" href="javascript:void(0);" routerLink="/home" routerLinkActive="active-menu">
        <i class="icofont-home"></i>
          <span>home</span>
      </a>
      <a class="mbn-col-3" href="javascript:void(0);" routerLink="/dashboard" routerLinkActive="active-menu">
        <i class="icofont-clock-time"></i>
          <span>inplay</span>
      </a>
      <a class="mbn-col-3" href="javascript:void(0);" (click)="confirmBox()">
        <i class="icofont-user"></i>
          <span>my bets</span>
      </a>
    </nav>
  </div>  <!-- mobile footer -->